var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.client.enable_time_sheets)?_c('div',[_c('b-link',{attrs:{"title":"Saisie des temps"},on:{"click":_vm.initModal}},[_c('strong',[_vm._v("T")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }